module.exports = __webpack_public_path__ + "img/electronic-business-plan.993c191d.png";